import axios from "axios";
import * as entityTypes from "../../types/admin/entityTypes";
import {
  getAuthConfigAndCompanyId,
  handleApiError,
} from "../../../utils/authUtils";

export const createEntityAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: entityTypes.CREATE_ENTITY_REQUEST,
    });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/create`,
      formData,
      config
    );

    // Check if the API response indicates success
    if (data.success === false) {
      throw new Error(data.message || "Failed to create entity");
    }

    dispatch({
      type: entityTypes.CREATE_ENTITY_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({
      type: entityTypes.CREATE_ENTITY_FAIL,
      payload: err,
    });
    throw err;
  }
};

export const getAllEntityListAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: entityTypes.GET_ALL_ENTITY_LIST_REQUEST,
    });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity`,
      config
    );

    dispatch({
      type: entityTypes.GET_ALL_ENTITY_LIST_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({
      type: entityTypes.GET_ALL_ENTITY_LIST_FAIL,
      payload: err,
    });
    throw err;
  }
};


export const getAllEntityWithoutPaginationAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: entityTypes.GET_ALL_ENTITY_REQUEST,
    });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/all`,
      config
    );

    dispatch({
      type: entityTypes.GET_ALL_ENTITY_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({
      type: entityTypes.GET_ALL_ENTITY_FAIL,
      payload: err,
    });
    throw err;
  }
};
export const getSingleEntityDetailsAction =
  (entityId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.GET_SINGLE_ENTITY_DETAILS_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/${entityId}`,
        config
      );

      dispatch({
        type: entityTypes.GET_SINGLE_ENTITY_DETAILS_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.GET_SINGLE_ENTITY_DETAILS_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateEntityOverviewAction =
  (entityId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.UPDATE_ENTITY_OVERVIEW_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/${entityId}`,
        formData,
        config
      );
      dispatch({
        type: entityTypes.UPDATE_ENTITY_OVERVIEW_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.UPDATE_ENTITY_OVERVIEW_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateEntityFormatsAction =
  (entityId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.UPDATE_ENTITY_FORMATS_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity-formats/${entityId}`,
        formData,
        config
      );

      // Check if the API response indicates success
      if (data.success === false) {
        throw new Error(data.message || "Failed to update entity formats");
      }

      dispatch({
        type: entityTypes.UPDATE_ENTITY_FORMATS_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.UPDATE_ENTITY_FORMATS_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const createEntityFormatsAction =
  (entityId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.CREATE_ENTITY_FORMATS_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity-formats/create`,
        { entityId, ...formData },
        config
      );

      // Check if the API response indicates success
      if (data.success === false) {
        throw new Error(data.message || "Failed to create entity formats");
      }

      dispatch({
        type: entityTypes.CREATE_ENTITY_FORMATS_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.CREATE_ENTITY_FORMATS_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getEntityFormatsAction =
  (entityId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.GET_ENTITY_FORMATS_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.get(
        // http://localhost:6001/api/admin/6450c0dd83f95e00139eaa85/entity-formats/68fa3c34767bcef73b20dd05
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity-formats/${entityId}`,
        config
      );

      dispatch({
        type: entityTypes.GET_ENTITY_FORMATS_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.GET_ENTITY_FORMATS_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const addEntityCommentsAction =
  (entityId, commentData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.ADD_ENTITY_COMMENTS_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/${entityId}/comments`,
        commentData,
        config
      );

      // Check if the API response indicates success
      if (data.success === false) {
        throw new Error(data.message || "Failed to add comment");
      }

      dispatch({
        type: entityTypes.ADD_ENTITY_COMMENTS_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.ADD_ENTITY_COMMENTS_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getEntityCommentsAction =
  (entityId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.GET_ENTITY_COMMENTS_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/${entityId}/comments`,
        config
      );

      dispatch({
        type: entityTypes.GET_ENTITY_COMMENTS_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.GET_ENTITY_COMMENTS_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getEntityActivityLogsAction =
  (entityId, page = 1, limit = 10) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: entityTypes.GET_ENTITY_ACTIVITY_LOGS_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/${entityId}/activity-logs?page=${page}&limit=${limit}`,
        config
      );

      dispatch({
        type: entityTypes.GET_ENTITY_ACTIVITY_LOGS_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: entityTypes.GET_ENTITY_ACTIVITY_LOGS_FAIL,
        payload: err,
      });
      throw err;
    }
  };
